import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { injectIntl, defineMessages } from 'react-intl';
import api from '@/shared/api';
import config from '@/config';
import intlShape from '@/shared/utils/intlShape';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import guid from '@/shared/utils/guid';
import MultiSelect, { removeItem, addItem, splitItems } from './MultiSelect';

const messages = defineMessages({
  WithoutTeams: 'Without teams',
  Teams: 'Teams',
});

const TeamMultiSelect = ({ selection = [], onChange, intl, idProp = 'id' }) => {
  const [items, setItems] = useState(intl);

  useEffect(() => {
    let mounted = true;
    api.base.get(`${config.appUrls.api}/api/team/MyTeams`).then(({ data }) => {
      if (!mounted) return;

      setItems([
        { id: guid.empty, label: intl.formatMessage(messages.WithoutTeams), code: 0 },
        ...data.map(({ id, name, code }) => ({ id, label: name, code })).sort(dynamicSort('label')),
      ]);
    });
    return () => {
      mounted = false;
    };
  }, [intl]);

  const [selectedItems, selectableItems] = splitItems(items, selection, idProp);

  return (
    <MultiSelect
      selectedItem={selectedItems}
      onItemRemoved={item => onChange(removeItem(selection, item, idProp))}
      onItemSelected={item => onChange(addItem(selection, item, idProp))}
      items={selectableItems}
      placeholder={intl.formatMessage(messages.Teams)}
    />
  );
};
TeamMultiSelect.propTypes = {
  selection: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  idProp: PropTypes.string,
};

export default injectIntl(TeamMultiSelect);
